import iso8601 from "iso8601-duration";
import { durationToSeconds } from "../utils/duration.js";
import { generateSrcSet } from "../utils/srcset.js";
import { NonPlayableIcons } from "./player-types.js";
function parseMetadata(metadata, startTime) {
  const images = metadata.preplay.poster.images;
  const availability = parseAvailability(metadata);
  const posterSrcset = generateSrcSet(images);
  const accessibilityVersions = metadata._embedded.manifests ? metadata._embedded.manifests.map((m) => {
    return { id: m.id, label: m.availabilityLabel, type: m._links.self.name };
  }) : [];
  const manifestSubtitles = metadata._embedded.manifestSubtitles ? metadata._embedded.manifestSubtitles.map((manifest) => ({
    id: manifest.id,
    availabilityLabel: manifest.availabilityLabel,
    href: manifest._links.self.href,
    type: manifest._links.self.name
  })) : [];
  const manifests = [].concat(accessibilityVersions, manifestSubtitles) || [];
  const nextSrc = parseNextSrc(metadata);
  return {
    availability,
    description: metadata.preplay.description,
    duration: metadata.duration ? iso8601.toSeconds(iso8601.parse(metadata.duration)) : 0,
    heading: metadata.preplay.titles.title,
    id: metadata.id,
    isLive: metadata.streamingMode === "live",
    isChannel: metadata.availability.live?.type === "channel",
    legalAge: metadata.legalAge,
    startTime,
    posterSrcset,
    nextSrc,
    subheading: metadata.preplay.titles.subtitle,
    standaloneProgram: metadata._links.series || metadata.availability.live?.type === "channel" ? false : true,
    interactionPoints: metadata.interactionPoints,
    indexPoints: parseIndexPoints(metadata.preplay.indexPoints),
    manifests,
    accessibilityVersions,
    manifestSubtitles
  };
}
function parseNextSrc(metadata) {
  if (!metadata._embedded.next) {
    return void 0;
  }
  const url = metadata._embedded.next._links.self.href;
  const id = url.substring(url.lastIndexOf("/") + 1);
  return `nrk:program:${id}`;
}
function parseIndexPoints(indexPoints) {
  return indexPoints.map((point) => {
    return {
      title: point.title,
      startPoint: durationToSeconds(point.startPoint),
      webImages: point.thumbnails?.map((t) => {
        return { uri: t.url, width: t.pixelWidth };
      })
    };
  });
}
function parseAvailability(metadata) {
  const { live, onDemand } = metadata.availability || {};
  const availability = {
    available: metadata.playability === "playable",
    to: /* @__PURE__ */ new Date(),
    from: /* @__PURE__ */ new Date()
  };
  if (live && live.transmissionInterval) {
    availability.from = new Date(live.transmissionInterval.from);
    availability.to = new Date(live.transmissionInterval.to);
  }
  if (onDemand) {
    availability.from = new Date(onDemand.from);
    availability.to = new Date(onDemand.to);
  }
  if (metadata.nonPlayable) {
    availability.reason = metadata.nonPlayable.reason;
    availability.endUserMessage = metadata.nonPlayable.endUserMessage;
    availability.endUserMessageSupplement = metadata.nonPlayable.endUserMessageSupplement ?? "";
    availability.endUserIcon = mapToEndUserIcon(metadata.nonPlayable.messageType);
    availability.messageType = metadata.nonPlayable.messageType;
    availability.helpUrl = metadata.nonPlayable.helpUrl;
  }
  availability.isPending = availability.from ? Date.now() < availability.from.getTime() : false;
  return availability;
}
function mapToEndUserIcon(messageType) {
  if (messageType === "ProgramRightsHasNotStarted" || messageType === "ProgramRightsHasExpired" || messageType === "ProgramUnavailable" || messageType === "ChannelUnavailable") {
    return NonPlayableIcons.nrkPlayFailIcon;
  } else if (messageType === "ProgramExceedsProfileRestrictions" || messageType === "ChannelExceedsProfileRestrictions") {
    return NonPlayableIcons.nrkLockActiveIcon;
  } else if (messageType === "ProgramIsGeoblocked" || messageType === "ChannelIsGeoblocked" || messageType === "ProgramAvailableWithNorwegianResidentClaim" || messageType === "ChannelAvailableWithNorwegianResidentClaim") {
    return NonPlayableIcons.nrkGeoblockedIcon;
  }
  return "";
}
export {
  parseMetadata
};
